import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ISelectOption} from '../single-select/single-select.component';

@Component({
  selector: 'w-single-dropdown',
  templateUrl: './single-dropdown.component.html',
  styleUrls: ['./single-dropdown.component.scss']
})
export class SingleDropdownComponent implements OnInit {
  @Input() options: ISelectOption[];
  @Input() initialOption: ISelectOption;
  @Input() placeholder: string
  @Output() onValueChanges: EventEmitter<any> = new EventEmitter();
  @Input() type: string = 'basic';

  constructor() {
  }

  ngOnInit(): void {

  }

  onValueChange($event: ISelectOption) {
    this.onValueChanges.emit($event);
  }

}
